/**
 * vx-hero-banner is used to author CMS hero component where an image,
 *  text and video SRC can be authored.
 */
import { eventBus, globalEventBus } from '../../../modules/event-bus';
import videoPlayer from '../../common/vx-video-player/vx-video-player.vue';
import vxModal from '../../common/vx-modal/vx-modal.vue';
import mobileMixin from '../../common/mixins/mobile-mixin';
import { backgroundColor, raysImages } from '../../common/mixins/vx-enums';
import globals from '../../common/globals';
import viewSiteContent from '../../../locale/view-site-content-i18n';

export default {
  name: 'vx-hero-banner',
  components: {
    vxModal,
    videoPlayer,
  },
  mixins: [mobileMixin],
  props: {
    heroBannerData: {
      type: Object,
      required: true,
    },
    isCategoriesBanner: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      backgroundColor,
      raysImages,
      globals,
      i18n: viewSiteContent.heroBanner,
    };
  },
  computed: {
    /**
     * used to set the background color for the banner
     * @return {object} object with background color as key
     */
    backgroundStyle() {
      return !this.heroBannerData.subHeadBgColor ||
        this.heroBannerData.subHeadBgColor === ''
        ? {
          'background-color': this.backgroundColor.transparent,
        }
        : {
          'background-color': this.heroBannerData.subHeadBgColor,
        };
    },
    /**
     * returns the alt text of the background
     */
    backgroundAlt() {
      return this.getResponsiveAlt(
        this.heroBannerData.backgroundImageAltTextD,
        this.heroBannerData.backgroundImageAltTextT,
        this.heroBannerData.backgroundImageAltTextM,
      );
    },
  },
  created() {},
  async mounted() {
    if (this.isCategoriesBanner) {
      this.heroBannerData = this.globals.catergoryBannerData;
    }
  },
  methods: {
    /**
     * retuns position of matched string
     */
    hasRaysImage() {
      if (this.heroBannerData.componentTheme) {
        return (this.heroBannerData.componentTheme.indexOf(this.raysImages.calssname) !== -1);
      }
      return false;
    },
    /**
     * opens the video modal
     */
    openModal() {
      const videoSRC = this.heroBannerData.videoSrc;
      eventBus.$emit('open-player', videoSRC);
    },
    /**
     * emits the scroll-to event with link as payload
     * @param {string} link
     * @return {object} null
     */
    emitScrollSignal(link) {
      globalEventBus.$emit('scroll-to', link);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/view-site-content/vx-hero-banner-responsive/vx-hero-banner-responsive.js